import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiDevice,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  devices: UbiquitiApiDataItem<UbiquitiDevice>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  devices: [],
});
